<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3786_5902)">
<circle cx="8" cy="8.5" r="8" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0111 5.47091C12.2113 5.66113 12.2193 5.9776 12.0291 6.17779L6.60808 11.883L3.97982 9.25465C3.78456 9.05939 3.78456 8.7428 3.97982 8.54754C4.17509 8.35228 4.49167 8.35229 4.68693 8.54755L6.5898 10.4505L11.3042 5.48896C11.4944 5.28878 11.8109 5.2807 12.0111 5.47091Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_3786_5902">
<rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
